import styled from 'styled-components'

import {
  _2XS_Bold,
  _L_Bold,
  _M_Medium,
  _M_Normal,
  mainColors,
  shadowColors,
} from '@avantstay/backoffice-core'

export const Container = styled.div`
  position: absolute;
  top: 56px;
  right: 4px;
  width: 430px;
  height: auto;
  min-height: 142px;
  background-color: ${mainColors.white};
  border: 1px solid ${mainColors.neutralMedium};
  border-radius: 4px;
  box-shadow: 0px 6px 32px 0px rgba(${shadowColors.blur}, 0.2);
  padding: 20px;
  text-align: left;
`

export const User = styled.div`
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid ${mainColors.neutralMedium};
  padding-bottom: 14px;

  & > span {
    display: flex;
    gap: 12px;
  }
`

export const UserName = styled.div`
  ${_L_Bold};
  line-height: 22px;
  text-align: left;
`

export const UserEmail = styled.div`
  ${_M_Normal};
  color: ${mainColors.neutralExtremelyDark};
  line-height: 19px;
  text-align: left;
`

export const LogoutBtn = styled.button`
  ${_M_Medium};
  display: flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  line-height: 19px;
  text-align: left;
  margin-top: 14px;
  color: ${mainColors.accentMedium};
`

export const MenuBtn = styled(LogoutBtn)``
